export const title2="En este momento, la información de Mapa del Estado se encuentra en proceso de actualización."